'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLiveHelp = function MdLiveHelp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.1 17.1c0.9-0.9 1.5-2.3 1.5-3.7 0-3.7-2.9-6.8-6.6-6.8s-6.6 3.1-6.6 6.8h3.2c0-1.8 1.6-3.4 3.4-3.4s3.4 1.6 3.4 3.4c0 0.9-0.4 1.7-1.1 2.3l-2 2.1c-1.2 1.3-1.9 2.9-1.9 4.7v0.9h3.2c0-2.5 0.8-3.6 2-4.8z m-3.5 12.9v-3.4h-3.2v3.4h3.2z m10-26.6c1.8 0 3.4 1.4 3.4 3.2v23.4c0 1.8-1.6 3.4-3.4 3.4h-6.6l-5 5-5-5h-6.6c-1.9 0-3.4-1.6-3.4-3.4v-23.4c0-1.8 1.5-3.2 3.4-3.2h23.2z' })
        )
    );
};

exports.default = MdLiveHelp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/live-help.js
// module id = 3009
// module chunks = 0